import * as tslib_1 from "tslib";
import { createSelector } from '@ngrx/store';
import * as auth from '../../auth/actions/auth.actions';
import * as facet from '../actions/facet';
import { hasProps } from '../../core/helpers/object';
import { applyOver, createUXFacetChips, createUXFacetGroups, prepFacetGroups, prepFacets } from '../../facets/helpers/facets';
import { getNewTtl } from '../../core/helpers/date';
var initialState = {
    initGroups: false,
    initFacets: false,
    groups: {},
    openGroups: [],
    facets: {},
    currentGroups: [],
    counts: {},
    applied: {},
    groupsTtl: null,
    facetsTtl: null
};
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case facet.INIT_GROUPS:
            return tslib_1.__assign({}, state, { initGroups: true });
        case facet.GET_GROUPS_SKIPPED:
            return tslib_1.__assign({}, state, { initGroups: false });
        case facet.GET_GROUPS_SUCCES:
            var groups = prepFacetGroups(action.payload);
            return tslib_1.__assign({}, state, { groups: groups, initGroups: false, groupsTtl: getNewTtl() });
        case facet.GET_GROUPS_FAILED:
            return tslib_1.__assign({}, state, { initGroups: false });
        case facet.INIT_FACETS:
            return tslib_1.__assign({}, state, { initFacets: true });
        case facet.GET_FACETS_SKIPPED:
            return tslib_1.__assign({}, state, { initFacets: false });
        case facet.GET_FACETS_SUCCESS:
            var facets = prepFacets(action.payload);
            return tslib_1.__assign({}, state, { initFacets: false, facets: facets, facetsTtl: getNewTtl() });
        case facet.GET_FACETS_FAILED:
            return tslib_1.__assign({}, state, { initFacets: false });
        case facet.APPLY:
            return tslib_1.__assign({}, state, { applied: action.payload });
        case facet.FILTER_SUCCESS:
            var incoming = applyOver(action.payload);
            return tslib_1.__assign({}, state, { counts: incoming, currentGroups: Object.keys(incoming) });
        case facet.FILTER_RESET:
            return tslib_1.__assign({}, state, { counts: {}, currentGroups: [], facets: {}, groups: {}, groupsTtl: null, facetsTtl: null });
        case facet.SHOW_MORE:
            var group_1 = action.payload;
            if (state.openGroups.indexOf(group_1) !== -1)
                return tslib_1.__assign({}, state, { openGroups: state.openGroups.filter(function (open) { return open !== group_1; }) });
            return tslib_1.__assign({}, state, { openGroups: state.openGroups.concat([
                    group_1
                ]) });
        case auth.LOGOUT:
            return initialState;
        default:
            return state;
    }
}
// Public Selectors
export var isInitializing = function (state) { return state.initFacets || state.initGroups; };
export var getFacets = function (state) { return state.counts; };
export var getGroups = function (state) { return state.groups; };
export var getApplied = function (state) { return state.applied; };
export var getBaseline = function (state) { return state.facets; };
export var getCurrentGroups = function (state) { return state.currentGroups; };
export var getOpenGroups = function (state) { return state.openGroups; };
export var isFacetGroupsTtlExpired = function (state) { return state.groupsTtl === null || state.groupsTtl < new Date(); };
export var isFacetsTtlExpired = function (state) { return state.facetsTtl === null || state.facetsTtl < new Date(); };
// Complex public selectors
export var hasApplied = createSelector(getApplied, function (applied) { return applied && hasProps(applied); });
export var hasGroups = createSelector(getGroups, function (groups) { return groups && hasProps(groups); });
export var hasBaseline = createSelector(getBaseline, function (baseline) { return baseline && hasProps(baseline); });
export var getFacetsUX = createSelector(getCurrentGroups, getGroups, getBaseline, getFacets, createUXFacetGroups);
export var getFacetChips = createSelector(getCurrentGroups, getFacetsUX, getApplied, createUXFacetChips);
export var combinedFacets = createSelector(getBaseline, getGroups, function (facets, groups) { return ({ facets: facets, groups: groups }); });
